import { render, staticRenderFns } from "./shipping_result.vue?vue&type=template&id=034a1626&scoped=true&"
import script from "./shipping_result.vue?vue&type=script&lang=js&"
export * from "./shipping_result.vue?vue&type=script&lang=js&"
import style0 from "./shipping_result.vue?vue&type=style&index=0&id=034a1626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a1626",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VImg,VList,VListItem,VListItemAvatar,VListItemContent})
